import { VueModule } from '@Foundation/utilities';
import Overlay from './code/Scripts/components/overlay.vue';

export default VueModule({
  components: {
    Overlay
  }
});
